/** API route map: URLS.Controller.PayrollDeliveryMethod */
export const PayrollDeliveryMethod = {
      Name: 'PayrollDeliveryMethod/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      GetbillingEventCode: 'get-billingEventCode',
      GetDeliveryMethodCode: 'get-deliveryMethodCode',
      GetAllDeliveryMethods: 'get-all-delivery-methods',
};
